import { Box, Button, TextField, Typography, alpha, styled } from '@mui/material';

export const HeaderTitleInteractionBox = styled(Box)(
  ({ theme }) => `
  display: flex;
  align-items: center;

  .svg-icon {
    height: 75px;
    width: 75px;
    margin-right: 3px;


    ${[theme.breakpoints.down('md')]} {
      height: 48px;
      width: 48px;
    }
  }
`,
);

export const InteractiveContentContainer = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
});

export const StyleRawTypography = styled(Typography)({
  p: {
    marginTop: 0,
    marginBottom: 0,
  },
});

export const StyleTextField = styled(TextField)<{
  width?: number;
  isError?: boolean;
  isCorrect?: boolean;
  isLoading?: boolean;
  fontSize?: number;
  fontFamily?: string;
}>(({ theme, width, isError, isCorrect, isLoading, multiline, fontSize, fontFamily }) => {
  let borderColor = 'rgba(0, 0, 0, 0.38)';
  let backgroundColor = 'transparent';
  if (isError) {
    borderColor = '#F44336';
    backgroundColor = 'rgba(244, 67, 54, 0.2)';
  } else if (isCorrect) {
    borderColor = theme.palette.borderSuccess?.primary || '';
    backgroundColor = theme.palette.backgroundSuccess?.primary || '';
  }

  return `
  background-color: ${backgroundColor};
  border-radius: 4px;
  border: 1px solid ${borderColor};
  line-height: 24px;
  max-width: 100%;

  .MuiInputBase-root {
    ${multiline ? 'padding: 0;' : ''}
    max-width: 100%;
  }

  .MuiInputBase-input{
    ${width ? `width: ${width}px` : '100px'};
    max-width: 100%;
    padding: 8px 16px;
    box-sizing: content-box;
    font-size: ${fontSize || 24}px;
    font-family: ${fontFamily || 'inherit'};

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active{
      -webkit-background-clip: text !important;
    }
  }

  && .Mui-disabled {
    background-color: transparent;
    -webkit-text-fill-color: #000;
    color: #000;
    padding: 4px 8px;
  }
`;
});

export const StyleButton = styled(Button)(
  ({ theme }) => `
  height: auto;
  border-radius: 36px;
  min-height: 64px;
  white-space: nowrap;
  padding: 16px 40px;

  ${theme.breakpoints.down('lg')} {
    padding: 16px 28px;
  }

  && {
    display: flex;
    font-size: 24px;
  }

  &.MuiButton-text {
    background-color: transparent;
    padding: 10px 25px;
    color: ${theme.palette.primary.main};
  }

  &.MuiButton-contained {
    background-color: ${theme.palette.primary.main};
    color: #fff;
    min-width: 250px;
  }

  &.MuiButton-outlined {
    border: solid 1px rgba(36, 81, 46, 0.8);
    color: ${theme.palette.primary.main};
  }

  &&:disabled {
    background-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.26);

    .MuiCircularProgress-root {
      color: rgba(0, 0, 0, 0.26);
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.12) !important;
    }
  }
`,
);
